import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

export const GooglePlacesAutocompleteInput = ({ onPlaceSelect, selectedPlace }) => {
	const handleChange = (newPlace) => {
		if (onPlaceSelect) onPlaceSelect(newPlace);
	};

	return (
		<GooglePlacesAutocomplete
			apiKey="AIzaSyBrgpv8pbX_2Y8MnAKlmndOXar_QvKxG9M"
			autocompletionRequest={{
				types: ['establishment']
			}}
			selectProps={{
				id: 'places-autocomplete',
				placeholder: 'Find your store...',
				styles: {
					control: (provided) => ({
						...provided,
						borderRadius: '0.25rem',
						width: '100%',
							})
				},
				components: {
					IndicatorSeparator: () => null,
					DropdownIndicator: () => null
				},
				value: selectedPlace,
				onChange: handleChange,
				isClearable: true,
				autoFocus: true
			}}
		/>
	);
};
